module.exports = __webpack_public_path__ + "assets/img/user-3.c4cfc32f.jpg";